// Money always renders with exactly two decimal places (e.g. 18500.5 -> "18,500.50").
export function formatCurrency(n) {
  return Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
